<div class="flex-row-spacebetween-center">
    <p class="title-text">{{ title }}</p>
    <div class="flex-row-center-center">
        <app-system-icon *ngIf="showIcon && systemId" systemId="{{systemId}}"
            alt="{{systemIconAlt}}"></app-system-icon>
        <p class="quotation-deals">{{ amount }} {{ currency }}</p>
    </div>
</div>
